import { environment } from '../configuration/env';

/**
 * Checks if the mock is currently running.
 *
 * @param {object} props - The properties to control the mocking behavior.
 * @returns {boolean} - Returns `true` if the mock is running, otherwise `false`.
 *
 * This function determines if the mock is currently running based on the environment configuration
 *
 * Dependencies:
 * - `environment`: The configuration environment object.
 *
 * @example
 * const result = isMockRunning();
 * console.log(result); // Output depends on the environment configuration
 */
export const isMockRunning = () => {
  const mockParam = environment.VITE_APP_ENABLE_MOCK;

  return mockParam === 'true';
};
